import { styled } from '@mui/material';

import { ProgressbarProps } from './types';

export const Bar = styled('div')<Pick<ProgressbarProps, 'value' | 'color'>>(({ theme, value, color }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: color,
  transform: `translateX(${value - 100}%)`,
  transition: 'transform 0.3s',
  position: 'relative',
  '&:after': {
    ...theme.typography.h4Bold,
    content: `"${value}%"`,
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: value > 50 ? 'translate(-8px, -50%)' : 'translate(calc(100% + 8px), -50%)',
    color: value > 50 ? theme.palette.common.white : color,
    transition: 'transform 0.3s, color 0.3s',
  },
}));
